
angular.module('mtic.components.dashboards.teacher_general').component('teacherStudentsAgendaInfo', {
  templateUrl: 'template.html',
  bindings: {
    agenda: '<',
    students: '<'
  },
  controllerAs: 'agendaInfo',
  controller: function(language, $log, $timeout) {
    var agendaInfo = this;
    // General Methods
    var getDay = function(date){
      return moment(date).format('MMM-DD');
    }
    var getResource = function(resourceId) {
      for(var resourceIndex in agendaInfo.agenda.resourceRefs){
        var resource = agendaInfo.agenda.resourceRefs[resourceIndex];
        if(Number(resource.id) === Number(resourceId)) {
          return resource;
        }
      }
      throw new Error('Missing Resource ID! ' + resourceId)
    }
    var makeNewStudentRow = function(student){
      var studentRow = {
        user_id: student.user_id,
        student_name: student.display_name,
        info: student.info,
        resources: {}
      };
      agendaInfo.resources.forEach(function(resource){
        studentRow.resources[resource.slug] = {};
      })
      return studentRow;
    }

    // Table Functions
    agendaInfo.getRows = function(){
      return _.toArray(agendaInfo.studentRows)
    }
    agendaInfo.getCols= function(){
      return agendaInfo.resources;
    }
    agendaInfo.getResourceName = function(slug, name) {
      var text = language.get(slug);
      return text ? text : name;
    }
    agendaInfo.hasAllTasksCompleted = function(studentRow){
      return _.filter(studentRow.resources,function(resourceWork){
        return resourceWork.resource_completed;
      }).length === _.toArray(studentRow.resources).length;
    }
    // Init
    agendaInfo.$onChanges = function(obj){
      $timeout(function(){
        agendaInfo.studentRows = {};
        agendaInfo.resources = [];
        agendaInfo.day = '';
        agendaInfo.description = '';


        // Grab time and description
        agendaInfo.day = getDay(agendaInfo.agenda.date_close)
        agendaInfo.description = agendaInfo.agenda.description;

        // Loop to get table collumns
        agendaInfo.agenda.resources.forEach(function(resourceId) {
          agendaInfo.resources.push(getResource(resourceId))
        })

        // Loop to get table rows
        agendaInfo.students.forEach(function(student){
          agendaInfo.studentRows[student.user_id] = makeNewStudentRow(student);
        })

        // Update Rows
        agendaInfo.agenda.StudentAgendaItems.forEach(function(studentAgendaItem){
          // var student = studentAgendaItem.user;
          var resource = studentAgendaItem.resource;
          var studentRow = agendaInfo.studentRows[studentAgendaItem.user_id];
          if(studentRow && studentRow.resources[resource.slug]) {
            studentRow.resources[resource.slug] = {
              resource_completed: studentAgendaItem.resource_completed,
              resource_performance: studentAgendaItem.resource_performance,
              completed_at: moment(studentAgendaItem.competeled_at).format('YYYY-MM-DD'),
            }
          }
        })


        // $log.log('Agenda Info Change : ', agendaInfo.students)
      },500)

    }
  }
});
